import { useQuery } from "@tanstack/react-query";
import { activityApi } from "@/lib/api";
import { useSession } from "@/lib/store/session";
import { normaliseActivities, type Activity } from "@/lib/domain/activities";
import { keys } from "./keys";
import { roundUpMetres, useUser } from "./useUser";

const EMPTY: Activity[] = [];

/** The user's full activity list, normalised. Cached until a synch change invalidates it. */
export function useActivities() {
  const userId = useSession((s) => s.userId);
  const { data: user } = useUser();
  const roundUp = roundUpMetres(user?.roundUpPb);
  const q = useQuery({
    queryKey: keys.activities(userId),
    queryFn: activityApi.list,
    enabled: !!userId,
    staleTime: Infinity,
    select: (rows) => normaliseActivities(rows, roundUp),
  });
  return { ...q, activities: q.data ?? EMPTY };
}
